import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
    Form, Modal, ModalHeader, ModalBody,
} from "reactstrap";


// actions
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";


const CompleteSurvey = props => {
    const { modal, toggle } = props;
    const navigate = useNavigate()
    const goToSubmit = () => {
        toggle()
        navigate("/dashboard")
    }
    return (
        <React.Fragment>
            <Modal
                className="survey-completed-main"
                isOpen={modal} 
            >
                <ModalBody className="survey-completed">
                    <div
                        className="form-horizontal"
                    >
                        <div className="survey-completed-tick">
                            <i className="bx bx-check"></i>
                        </div>
                        <h3> {props.t("Thanks for Completing the Survey")}.</h3>
                        <button onClick={() => goToSubmit()}>{props.t("Submit")}</button>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};


CompleteSurvey.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(CompleteSurvey);

